<template src="./index.html"></template>
<script>
import { Search, Icon, Dialog, NoticeBar, Popup} from "vant";
import { mapState } from "vuex";
import DownScrollLoad from "@/utils/DownScrollLoad";
import LostPage from "@/components/LostPage";
import SelfTabbar from '@/components/SelfTabbar';
import ManualHelp from "@/components/ManualHelp_APP";
import CouponsPopup from "@/components/CouponsPopup";
import MerchantsDay20210312 from '@/components/MerchantsDay20210312_APP';
import { URL5 } from "@/utils/Redirect";
export default {
  name: "AddressBook",
  components: { Search, Icon, Dialog, LostPage, ManualHelp, CouponsPopup, SelfTabbar, MerchantsDay20210312, NoticeBar, Popup},
  computed: {
    ...mapState({
      getSappMenuInfo: (state) => {
        return state.Public.getSappMenuInfo;
      },
      AddressData: (state) => {
        return state.Public.AddressData;
      },
      adressListLength: (state) => {
        return state.AddressBook.adressListLength;
      },
      getTableData: (state) => {
        return state.AddressBook.getTableData;
      },
      AddressOffset: (state) => {
        return state.AddressBook.AddressOffset;
      },
      twoTitle: (state) => {
        return state.AddressBook.twoTitle;
      },
      scrollTopValue: (state) => {
        return state.AddressBook.scrollTopValue;
      },
      starMarkList: (state) => {
        return state.AddressBook.starMarkList;
      },
      noStarMarkList: (state) => {
        return state.AddressBook.noStarMarkList;
      },
    }),
  },
  data() {
    return {
      TabbarActive: 1,
      searchValue: "",
      searchTypeAction: "0",
      searchTypeList: [
        { index: "0", column_text: "全部", column_key: "", sort: "desc" },
      ],
      twoList: [],
      twoTitleList: [
        { name: "分销" },
        { name: "采购" },
        { name: "新客户" },
        { name: "老客户" },
        { name: "忠诚客户" },
        { name: "实体店主" },
        { name: "微分销" },
        { name: "淘分销" },
        { name: "贸易公司" },
        { name: "生产商" },
        { name: "行政采购" },
        { name: "个人自用" },
        { name: "其他" },
        { name: "初级客户（B1）" },
        { name: "中级客户（B2）" },
        { name: "高级客户（B3）" },
        { name: "1000元以下低客单价客户" },
        { name: "1000元-3000元之间的中客单价客户" },
        { name: "3000元以上高客单价客户" },
        { name: "未超期" },
        { name: "久未光顾" },
        { name: "平均1-2天购买一次" },
        { name: "平均3-7天买一次" },
        { name: "平均8-30天买一次" },
        { name: "平均30天以上买一次" },
      ],
      threeList: [],
      titleIndex: 0,
      footerShow: false,
      scrollBottom: 0,
      // 记录页面数据条数
      // offset: 0,
      dataObj: {
        column_key: "",
        // sort: "desc"
      },
      lostPageShow: false,
      contentShow: true,
      threeTitle: [],
      paramsData: {},
      new_params: {},
      saveData: {},
      oneType: 0,

      isFixed: false,
      searchFixed: false,
      offsetTop: 0,
      searchTop: 0,
      getDataNum: 0,
      lastText: false,
      shaiUpDown: true,
      shaiText: "",
      sort: "desc",
      DataListDone: false,
      dataShow: false,
      scrollLeftNum: 0,
      lostShow: false,
      contentShow01: false,
      userInfo: {},
      ListArrLength: 0,
      noRootShow: false, //账号到期
      popup_show: null, //微信打开的遮罩
      popup_img: "", //遮罩的图片
      lodingShow: false,
      scrollValue: 0,
      scrollBottomValue: '',
    };
  },
  methods: {

    scrollEvent(e) {
      this.initHeight()


      this.scrollValue = e.srcElement.scrollTop
      this.$store.commit("AddressBook/SET_DATA", {
        key: "scrollTopValue",
        data: this.scrollValue,
      });
      if (e.srcElement.scrollHeight - (e.srcElement.scrollTop + e.srcElement.clientHeight) < 100 ) {
        if(this.scrollBottomValue < e.srcElement.scrollTop) {
          this.dataObj.offset = this.AddressOffset;
          this.getListData();
        }
        this.scrollBottomValue = e.srcElement.scrollTop
      }
    },







    getTagData() {
      this.$store.dispatch("AddressBook/GetAddressBook").then((res) => {
        // 添加判断选中的属性
        let _index = 0;
        for (let i in res.data.one_level.data) {
          _index += 1;
          res.data.one_level.data[i].index = _index;
          this.searchTypeList.push(res.data.one_level.data[i]);
        }

        this.threeList = res.data.three_level.data;
        this.twoList = res.data.two_level;
        this.saveData.twoListArr = res.data.two_level

        for (let i in this.threeList) {
          this.threeList[i].activeClass = false;
        }
        if ((this.$route.params.LabelParams && Object.keys(this.$route.params.LabelParams).length >= 0)) {
          
          this.paramsData = this.$route.params.LabelParams;
        } else {
          if (this.$store.state.Public.AddressData) {
            this.paramsData = this.$store.state.Public.AddressData.twoTitle
              ? this.$store.state.Public.AddressData.twoTitle
              : "";
          }
        }
        this.saveData.twoTitle = this.paramsData;

        if (this.paramsData) {
          for (let i in this.paramsData) {
            for (let j in this.twoList) {
              if (this.twoList[j].key == i) {
                for (let k in this.twoTitleList) {
                  if (
                    this.twoTitleList[k].name ==
                    this.twoList[j].data[this.paramsData[i]].label_text
                  ) {
                    this.twoTitleList[k].activeClass = "1";
                  }
                }
                this.new_params[this.twoList[j].key] =
                this.twoList[j].data[this.paramsData[i]].label_value;
              }
            }
          }
        }
        this.dataObj = { ...this.dataObj, ...this.new_params };
        
        this.getTitleClass();
        this.getListData()
      });
    },
    // 获取列表数据
    getListData() {
      this.dataObj.offset = this.AddressOffset;
      if (this.QUERY_DATA_ING || this.lastText) {
        return false;
      }
      this.QUERY_DATA_ING = true; // 用来记录当前是否正在请求 , 如果正在请求则不继续发送请求
      if(this.$route.params.LabelParams&&this.$route.params.LabelParams.rVisitNum !== '') {
        this.new_params.customize_recall_num = this.$route.params.LabelParams&&this.$route.params.LabelParams.rVisitNum
      }
      this.dataObj = { ...this.dataObj, ...this.new_params };
      this.$store.dispatch("AddressBook/getTableData", this.dataObj).then((res) => {
        this.QUERY_DATA_ING = false; // 返回后重置请求状态
        
        // 返回的数据不为空
        // res.data = []
        if (res.data.length !== 0) {
          this.lodingShow = true
          this.lostPageShow = false;
          this.contentShow = true;
          this.contentShow01 = true;
          this.lastText = false;
          
          let starType = true
          for(let i in this.twoTitleList) {
            if(this.twoTitleList[i].activeClass == '1') {
              starType = false
            }
          }
          for(let i in this.threeList) {
            if(this.threeList[i].activeClass && i!=='0') {
              starType = false
            }
          }
          
          if(this.dataObj.customize_recall_num || 
            this.dataObj.customized ||
            this.dataObj.custom_level ||
            this.dataObj.custom_order_fee ||
            this.dataObj.custom_type ||
            this.dataObj.expired_date ||
            this.dataObj.member_type ||
            this.dataObj.order_type ||
            this.dataObj.pay_cycle ||
            this.dataObj.recall_num
            ) {
            starType = false
          }
          if(this.searchTypeAction==0 && starType) {
            let starMarkList = this.starMarkList
            let noStarMarkList = this.noStarMarkList
            for(let i in res.data) {
              if(res.data[i].row_data.star_mark == 1) {
                starMarkList.push(res.data[i])
                this.$store.commit("AddressBook/SET_DATA", {
                  key: "starMarkList",
                  data: starMarkList,
                });
              }else {
                noStarMarkList.push(res.data[i])
                this.$store.commit("AddressBook/SET_DATA", {
                  key: "noStarMarkList",
                  data: noStarMarkList,
                });
              }
            }
          }else {
            let noStarMarkList = this.noStarMarkList
            this.$store.commit("AddressBook/SET_DATA", {
              key: "starMarkList",
              data: [],
            });
            for(let i in res.data) {
              noStarMarkList.push(res.data[i])
              this.$store.commit("AddressBook/SET_DATA", {
                key: "noStarMarkList",
                data: noStarMarkList,
              });
            }
          }
        } else {
          if (this.getTableData.length > 0) {
            this.contentShow = true;
            this.contentShow01 = true;
            this.lostPageShow = false;
            this.lastText = true;

            let starType = true
            this.$store.commit("AddressBook/SET_DATA", {
              key: "starMarkList",
              data: [],
            });
            this.$store.commit("AddressBook/SET_DATA", {
              key: "noStarMarkList",
              data: [],
            });
            for(let i in this.twoTitleList) {
              if(this.twoTitleList[i].activeClass == '1') {
                starType = false
              }
            }
            
            if(this.dataObj.customize_recall_num || 
              this.dataObj.customized ||
              this.dataObj.custom_level ||
              this.dataObj.custom_order_fee ||
              this.dataObj.custom_type ||
              this.dataObj.expired_date ||
              this.dataObj.member_type ||
              this.dataObj.order_type ||
              this.dataObj.pay_cycle ||
              this.dataObj.recall_num
              ) {
              starType = false
            }
            if(this.searchTypeAction==0 && starType) {
              let starMarkList = []
              let noStarMarkList = this.noStarMarkList
              for(let i in this.getTableData) {
                if(this.getTableData[i].row_data.star_mark == 1) {
                  starMarkList.push(this.getTableData[i])
                  this.$store.commit("AddressBook/SET_DATA", {
                    key: "starMarkList",
                    data: starMarkList,
                  });
                }else {
                  noStarMarkList.push(this.getTableData[i])
                  this.$store.commit("AddressBook/SET_DATA", {
                    key: "noStarMarkList",
                    data: noStarMarkList,
                  });
                }
              }
            }else {
              this.$store.commit("AddressBook/SET_DATA", {
                key: "starMarkList",
                data: [],
              });
              for(let i in this.getTableData) {
                let noStarMarkList = this.noStarMarkList
                noStarMarkList.push(this.getTableData[i])
                this.$store.commit("AddressBook/SET_DATA", {
                  key: "noStarMarkList",
                  data: noStarMarkList,
                });
              }
            }
          }else {
            if(Object.keys(this.new_params).length > 0) {
              this.contentShow = true;
              this.contentShow01 = true;
              this.lostPageShow = true;
              this.lastText = false;
              this.scrollBottom = 0;
              this.lodingShow = true
            }else {
              DownScrollLoad.remove();
              if(this.userInfo.is_overdue==0) {
                this.contentShow01 = false
                this.lostShow = true
              }
              else if(this.userInfo.is_overdue==1) {
                this.contentShow01 = false
                this.noRootShow = true
              }
            }
          }
        }
        // 保存下次请求传递的数据条数 = 当前页面显示列表的总条数
        this.$store.commit("AddressBook/offset_set", this.getTableData.length);
      });
    },
    SwitchSearchTypeAction(index) {
      this.$store.commit("AddressBook/SET_DATA", {
        key: "starMarkList",
        data: [],
      });
      this.$store.commit("AddressBook/SET_DATA", {
        key: "noStarMarkList",
        data: [],
      });
      this.$store.dispatch("Public/inH5Record", {
        btn_name: "通讯录一级标签",
        page_param: { titleName: this.searchTypeList[index].column_text },
      });

      this.oneType = 1;
      this.saveData.oneTitle = this.searchTypeList[index].column_key;
      this.saveData.oneTitleText = this.searchTypeList[index].column_text;
      this.saveData.sort = this.sort;
      this.$store.commit("Public/SET_DATA", {
        key: "AddressData",
        data: this.saveData,
      });
      this.searchTypeAction = index;
      this.dataObj.column_key = this.searchTypeList[index].column_key;
      this.$store.commit("AddressBook/offset_set", 0);
      this.$store.commit("AddressBook/SET_DATA", {
        key: "getTableData",
        data: [],
      });
      this.dataObj.sort = this.sort;
      this.lastText = false;
      this.dataObj = { ...this.dataObj, ...this.new_params };
      this.getListData();
      let oneText = this.searchTypeList[this.searchTypeAction].column_text;
      if (oneText == "累计交易金额" || oneText == "客单价金额") {
        this.shaiText = this.sort=='desc' ?"金额（高到低）" :'金额（低到高）';
      }
      if (oneText == "购买次数") {
        this.shaiText = this.sort=='desc' ?"次数（多到少）" :'次数（少到多）';
      }
      if (oneText == "交易时间" || oneText == "添加时间") {
        this.shaiText = this.sort=='desc' ?"时间（近到远）" :'时间（远到近）';
      }
      if (oneText == "超期未购" || oneText == "购买周期") {
        this.shaiText = this.sort=='desc' ?"天数（大到小）" :'天数（小到大）';
      }
    },
    stroePV(item, name) {
      // 存储点击店铺列表的pv,uv
      this.$store.dispatch("Public/inH5Record", {
        btn_name: "通讯录客户列表",
        page_param: item,
      });

      this.$router.push({
        path:'CustomerInfo_APP', 
        query: {
          source:'2', 
          ww_nick: name,
          buyer_openuid:item.buyer_openuid,
          is_in_list: 1,
      }})
    },
    // 筛选按钮
    shaiBtn() {
      this.$router.push({
        name: "LabelPage",
        params: { LabelParams: this.paramsData },
      });
    },
    shaiBtn_2() {
      this.$store.commit("AddressBook/SET_DATA", {
        key: "starMarkList",
        data: [],
      });
      this.$store.commit("AddressBook/SET_DATA", {
        key: "noStarMarkList",
        data: [],
      });
      this.$store.commit("AddressBook/offset_set", 0);
      this.$store.commit("AddressBook/SET_DATA", {
        key: "getTableData",
        data: [],
      });
      
      this.shaiUpDown = !this.shaiUpDown;
      if (this.shaiUpDown) {
        this.dataObj.sort = this.sort = "desc";
      } else {
        this.dataObj.sort = this.sort = "asc";
      }
      this.saveData.sort = this.sort;
      this.dataObj.offset = 0;
      this.lastText = false
      this.getListData();
      let oneText = this.searchTypeList[this.searchTypeAction].column_text;
      if (oneText == "累计交易金额" || oneText == "客单价金额") {
        this.shaiText = this.sort=='desc' ?"金额（高到低）" :'金额（低到高）';
      }
      if (oneText == "购买次数") {
        this.shaiText = this.sort=='desc' ?"次数（多到少）" :'次数（少到多）';
      }
      if (oneText == "交易时间" || oneText == "添加时间") {
        this.shaiText = this.sort=='desc' ?"时间（近到远）" :'时间（远到近）';
      }
      if (oneText == "超期未购" || oneText == "购买周期") {
        this.shaiText = this.sort=='desc' ?"天数（大到小）" :'天数（小到大）';
      }
    },
    // 切换标签事件
    changeTitle(index, name) {
      document.getElementById('AddressBook').scrollTo(0, 0)
      setTimeout(()=> {
        this.initHeight()
      },10)
      this.$store.commit("AddressBook/offset_set", 0);
      this.$store.commit("AddressBook/SET_DATA", {
        key: "getTableData",
        data: [],
      });
      this.$store.commit("AddressBook/SET_DATA", {
        key: "starMarkList",
        data: [],
      });
      this.$store.commit("AddressBook/SET_DATA", {
        key: "noStarMarkList",
        data: [],
      });
      if(name !== '全部') {
      }else {

      }
      this.lastText = false
      this.getListData()
      this.$store.dispatch("Public/inH5Record", {
        btn_name: "通讯录三级标签",
        page_param: { titleName: name },
      });
      this.threeTitle = [];
      this.$forceUpdate();
      if (name == "全部") {
        for(let i in this.getTableData) {
          if(this.getTableData[i].row_data.star_mark == 1) {
            this.starMarkList.push(this.getTableData[i])
          }else {
            this.noStarMarkList.push(this.getTableData[i])
          }
        }
        if (!this.threeList[index].activeClass) {
          for (let i in this.threeList) {
            this.threeList[i].activeClass = false;
          }
        }
      }else {
        this.threeList[0].activeClass = false;
        this.$store.commit("AddressBook/SET_DATA", {
          key: "starMarkList",
          data: [],
        });
        this.$store.commit("AddressBook/SET_DATA", {
          key: "starMarkList",
          data: this.getTableData,
        });
      }

      for (let i in this.threeList) {
        if (this.threeList[i].label_text == "全部") {
          if (this.threeList[i].activeClass == true) {
            this.threeList[index].activeClass = false;
          } else {
            this.threeList[index].activeClass =
              !this.threeList[index].activeClass;
          }
        }
        if (this.threeList[i].activeClass == true) {
          this.threeTitle.push(this.threeList[i].label_text);
        }
      }

      this.saveData.threeTitle = this.threeTitle;

      if (
        this.threeTitle.indexOf("微信") !== -1 ||
        this.threeTitle.indexOf("短信") !== -1
      ) {
        this.footerShow = true;
        if(this.getTableData.length == 0) {
          this.scrollBottom = 0;
        }else {
          this.scrollBottom = 1;
        }
      } else {
        this.footerShow = false;
        this.scrollBottom = 0;
      }
      this.titleIndex = index;


      let threeArr = []
      for(let i in this.threeList) {
        if(this.threeList[i].activeClass) {
          threeArr.push(this.threeList[i].label_value)
        }
      }
      this.dataObj.channel = threeArr[0]=='' ?[] :threeArr
      this.dataObj = { ...this.dataObj, ...this.new_params };
    },
    sendNews() {
      this.$store.dispatch("Public/inH5Record", {
        btn_name: "通讯录群发消息",
        page_param: { titleName: this.threeTitle },
      });

      Dialog.alert({
        title: "",
        message: "该功能正在开发中\n敬请期待",
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: "关闭",
        width: "80vw",
        className: "CustomerWarnTan",
      }).catch(() => {});
    },
    // 取整
    getInt(num) {
      if(Number(num)) {
        if (num < 10000) {
          return parseInt(num);
        } else {
          return parseInt(num / 10000);
        }
      }else {
        return '0'
      }
    },
    // 取小数
    getFixed(num) {
      if(Number(num)) {
        if (num < 10000) {
          let str = String(num).split(".")[1];
          if (str) {
            if(str.length < 2) {
              if(Number(str) < 10 && str !== '00') {
                str = str + '0'
              }
            }
            return str;
          } else {
            return "00";
          }
        } else {
          let str = String((Math.floor(((num / 10000) * 100)) / 100)).split(".")[1]
          if (str) {
            if(str.length < 2) {
              if(Number(str) < 10 && str !== '00') {
                str = str + '0'
              }
            }
            return str;
          } else {
            return "00";
          }
        }
      }else {
        return '00'
      }
    },
    searchBtn() {
      this.$router.push({name:"AddressBookSearchPage",params: {active: "focus"}});
    },
    getTitleClass() {
      this.dataShow = true;
      this.contentShow01 = true
      if (this.$store.state.Public.AddressData) {

        if (this.$store.state.Public.AddressData.oneTitleText) {
          for (let i in this.searchTypeList) {
            if (
              this.searchTypeList[i].column_text ==
              this.$store.state.Public.AddressData.oneTitleText
            ) {
              this.searchTypeAction = i;
            }
          }
        }
        this.threeTitle = [];
        if (
          Object.keys(this.$store.state.Public.AddressData.threeTitle).length >
          0
        ) {
          for (let i in this.$store.state.Public.AddressData.threeTitle) {
            this.threeTitle.push(
              this.$store.state.Public.AddressData.threeTitle[i]
            );
            for (let j in this.threeList) {
              if (
                this.threeList[j].label_text ==
                this.$store.state.Public.AddressData.threeTitle[i]
              ) {
                this.threeList[j].activeClass = true;
              }
            }
          }
          if (
            this.threeTitle.indexOf("微信") !== -1 ||
            this.threeTitle.indexOf("短信") !== -1
          ) {
            this.footerShow = true;
            this.scrollBottom = 1;
          } else {
            this.footerShow = false;
            this.scrollBottom = 0;
          }
        } else {
          this.threeList[0].activeClass = true;
        }

        if (
          this.$store.state.Public.AddressData.sort &&
          this.$store.state.Public.AddressData.sort !== "desc"
        ) {
          this.shaiUpDown = false;
        } else {
          this.shaiUpDown = true;
        }


        let starType = true
        for(let i in this.twoTitleList) {
          if(this.twoTitleList[i].activeClass == '1') {
            starType = false
          }
        }
        for(let i in this.threeList) {
          if(this.threeList[i].activeClass && i!=='0') {
            starType = false
          }
        }
        if(this.dataObj.customize_recall_num || 
          this.dataObj.customized ||
          this.dataObj.custom_level ||
          this.dataObj.custom_order_fee ||
          this.dataObj.custom_type ||
          this.dataObj.expired_date ||
          this.dataObj.member_type ||
          this.dataObj.order_type ||
          this.dataObj.pay_cycle ||
          this.dataObj.recall_num
          ) {
          starType = false
        }
        
      } else {
        this.threeList[0].activeClass = true;
      }
      let oneText = this.searchTypeList[this.searchTypeAction].column_text;
      if (oneText == "累计交易金额" || oneText == "客单价金额") {
        this.shaiText = this.sort=='desc' ?"金额（高到低）" :'金额（低到高）';
      }
      if (oneText == "购买次数") {
        this.shaiText = this.sort=='desc' ?"次数（多到少）" :'次数（少到多）';
      }
      if (oneText == "交易时间" || oneText == "添加时间") {
        this.shaiText = this.sort=='desc' ?"时间（近到远）" :'时间（远到近）';
      }
      if (oneText == "超期未购" || oneText == "购买周期") {
        this.shaiText = this.sort=='desc' ?"天数（远到近）" :'天数（近到远）';
      }
      if ((this.$route.params.LabelParams && Object.keys(this.$route.params.LabelParams).length >= 0)) {
        
        this.paramsData = this.$route.params.LabelParams;
        
      } else {
        if (this.$store.state.Public.AddressData) {
          this.paramsData = this.$store.state.Public.AddressData.twoTitle
            ? this.$store.state.Public.AddressData.twoTitle
            : "";
        }
      }
      if (Object.keys(this.paramsData).length >= 0) {
        for (let i in this.paramsData) {
          for (let j in this.twoList) {
            if (this.twoList[j].key == i) {
              for (let k in this.twoTitleList) {
                if (
                  this.twoTitleList[k].name ==
                  this.twoList[j].data[this.paramsData[i]].label_text
                ) {
                  this.twoTitleList[k].activeClass = "1";
                }
              }
              this.new_params[this.twoList[j].key] =
              this.twoList[j].data[this.paramsData[i]].label_value;
            }
          }
        }
      }
      this.saveData.twoTitle = this.paramsData;

      
      let threeArr = []
      for(let i in this.threeList) {
        if(this.threeList[i].activeClass) {
          threeArr.push(this.threeList[i].label_value)
        }
      }
      this.dataObj.channel = threeArr[0]=='' ?[] :threeArr
      this.dataObj = { ...this.dataObj, ...this.new_params };
      this.$nextTick(()=>{
        this.$refs.sortMenu.scrollLeft = this.scrollLeftNum;
      })
    },
    initHeight() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.offsetTop = document.querySelector("#boxFixed")
        ? document.querySelector("#boxFixed").offsetTop
        : "";
      this.isFixed = this.scrollValue>98 || this.scrollTopValue>98 ? true : false;
      
    },
    handleScroll() {
      this.scrollLeftNum = this.$refs.sortMenu.scrollLeft
    },
    init() {
      
      if (this.$store.state.Public.AddressData) {
        setTimeout(()=>{
          document.getElementById('AddressBook').scrollTo(0, this.scrollTopValue)
        },0)

        this.dataObj.column_key = this.$store.state.Public.AddressData.oneTitle
          ? this.$store.state.Public.AddressData.oneTitle
          : "";
        this.dataObj.offset = this.AddressOffset;
        this.sort = this.$store.state.Public.AddressData.sort
          ? this.$store.state.Public.AddressData.sort
          : "desc";
        this.dataObj.sort = this.$store.state.Public.AddressData.sort
          ? this.$store.state.Public.AddressData.sort
          : this.sort;
        this.scrollLeftNum = this.$store.state.Public.AddressData.scrollLeftNum
          ? this.$store.state.Public.AddressData.scrollLeftNum
          : 0;
      }
      if(!(this.getTableData && this.getTableData.length !== 0)) {
        this.getTagData()
      }else {
        this.lodingShow = true
        this.paramsData = this.$store.state.Public.AddressData.twoTitle
        if (this.$store.state.Public.AddressData) {
          if(this.$store.state.Public.AddressData.oneTitleArr) {
            this.searchTypeList = this.$store.state.Public.AddressData.oneTitleArr
          }
          if(this.$store.state.Public.AddressData.threeTitleArr) {
            this.threeList = this.$store.state.Public.AddressData.threeTitleArr
          }
          if(this.$store.state.Public.AddressData.twoTitleArr) {
            this.twoTitleList = this.$store.state.Public.AddressData.twoTitleArr
          }
          if(this.$store.state.Public.AddressData.twoListArr) {
            this.twoList = this.$store.state.Public.AddressData.twoListArr
          }
          this.getTitleClass();
        }

      }
      
    },
    jump_router() {

      if (this.$config.WebOS == "wx") {
        this.popup_show = true;
        if (!window.location.hash.includes("jump_link=1")) {
          history.replaceState({}, 0, window.location.href + "?jump_link=1");
        }
        if (this.$config.SystemOS == "IOS") {
          this.popup_img = this.$OSS + "renew_tips_ios.png";
        } else {
          this.popup_img = this.$OSS + "renew_tips_android.png";
        }
      } else {
        window.open(URL5);
      }
    },
    popup_close() {
      if (window.location.hash.includes("jump_link=1")) {
        history.replaceState(
          {},
          0,
          window.location.href.replace("?jump_link=1", "")
        );
      }
    },
  },
  created(){
    let reload_one = sessionStorage.getItem('reload_one')
    if( reload_one == '1' ){
      sessionStorage.removeItem('reload_one');
      location.reload();
    }
  },
  mounted() {
    this.userInfo = this.$store.state.Public.AccountInfo
    // this.userInfo.is_boss = 0 

    if(this.userInfo.is_boss == 0) {
      this.contentShow01 = false
      this.lostShow = true
    }else {
      this.init()
    }

  },
  beforeDestroy() {
    DownScrollLoad.remove();
    this.saveData.oneTitle =
      this.searchTypeList[this.searchTypeAction].column_key;
    this.saveData.oneTitleText =
      this.searchTypeList[this.searchTypeAction].column_text;
    this.saveData.threeTitle = this.threeTitle;
    this.saveData.sort = this.sort;

    this.saveData.oneTitleArr = this.searchTypeList
    this.saveData.threeTitleArr = this.threeList
    this.saveData.twoTitleArr = this.twoTitleList
    this.saveData.twoListArr = this.twoList

    this.saveData.scrollLeftNum = this.scrollLeftNum


    this.$store.commit("Public/SET_DATA", {
      key: "AddressData",
      data: this.saveData,
    });
  },
};
</script>
<style lang="scss" src="./index.scss" scoped></style>
<style lang="scss">
#AddressBook .van-tabbar {
  z-index: 20;
}
</style>